import { FileSelectionFilter, lazyAttachmentFilePicker } from 'owa-attachment-filepicker';
import EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { lazyInsertLinks } from 'owa-insert-link';
import { InsertLinksHost } from 'owa-attachment-link-common';

export const openFilePickerForInsertLinksHandler = (
    insertLinkshost: InsertLinksHost,
    editorViewState: EditorViewState,
    targetWindow: Window,
    fromAddress: string
) => {
    lazyAttachmentFilePicker.importAndExecute(
        null /* createAttachmentHandler */,
        async params => {
            const insertLinks = await lazyInsertLinks.import();
            insertLinks(params.files, insertLinkshost, editorViewState, fromAddress);
        },
        {
            fileSelectionFilter: FileSelectionFilter.None,
            disableLocalComputerFilePicker: true,
            targetWindow,
        }
    );
};
